"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _ObjectTypesType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/ObjectTypesType"));

var _immutable = require("immutable");

var _throttle = _interopRequireDefault(require("transmute/throttle"));

var _customErrorTypes = require("crm_ui/constants/customErrorTypes");

var _ComponentWithIntervals = _interopRequireDefault(require("UIComponents/mixins/ComponentWithIntervals"));

var _TimelineFetchingActions = require("crm_data/timeline/TimelineFetchingActions");

var _TimelineStatusStore = _interopRequireDefault(require("crm_ui/timeline/data/stores/TimelineStatusStore"));

var _ProfileTimelineErrorMessage = _interopRequireDefault(require("crm_ui/timeline/components/config/ProfileTimelineErrorMessage"));

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var _SubjectType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/SubjectType"));

var _TimelineConstants = require("crm_universal/timeline/TimelineConstants");

var _TimelineCreateSourceEvent = _interopRequireDefault(require("crm_ui/timeline/components/events/TimelineCreateSourceEvent"));

var _TimelineCard = _interopRequireDefault(require("crm_ui/timeline/components/generic/TimelineCard"));

var _ETypes = _interopRequireDefault(require("crm_universal/timeline/ETypes"));

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var _TimelinePinnedEngagement = _interopRequireDefault(require("crm_ui/timeline/components/generic/TimelinePinnedEngagement"));

var _TimelineEventContainer = _interopRequireDefault(require("./TimelineEventContainer"));

var _TimelineZeroStateAdvancedFilters = _interopRequireDefault(require("crm_ui/timeline/components/config/TimelineZeroStateAdvancedFilters"));

var _TimelineEvents = _interopRequireDefault(require("./TimelineEvents"));

var _TimelineStickyEvent = _interopRequireDefault(require("./TimelineStickyEvent"));

var _TimelineFilterHelpers = _interopRequireDefault(require("crm_ui/timeline/helpers/TimelineFilterHelpers"));

var _TimelineEventHelpers = require("crm_ui/timeline/helpers/TimelineEventHelpers");

var now = _TimelineStatusStore.default.get('now');

var months = _TimelineConstants.UNITS_OF_TIME.get('MONTHS');

var ONE_MINUTE = 60000;
var POLLING_INTERVAL = 120000;
var Timeline = (0, _createReactClass.default)({
  mixins: [_ComponentWithIntervals.default],
  propTypes: {
    activityTabIsSelected: _propTypes.default.bool,
    emailTabIsSelected: _propTypes.default.bool,
    events: _TimelineEventHelpers.TimelineEventsPropType,
    favoriteEventOverride: _propTypes.default.instanceOf(_immutable.Map),
    hasPinnedEngagement: _propTypes.default.bool,
    objectType: _ObjectTypesType.default.isRequired,
    profileStartTime: _propTypes.default.number,
    searchText: _propTypes.default.string.isRequired,
    selectedTeams: _reactImmutableProptypes.default.list.isRequired,
    selectedUsers: _reactImmutableProptypes.default.list.isRequired,
    subject: _SubjectType.default,
    subjectId: _propTypes.default.string.isRequired,
    timelineFavoriteEvents: _propTypes.default.instanceOf(_immutable.List),
    timelineStatus: _propTypes.default.instanceOf(_immutable.Map)
  },
  getDefaultProps: function getDefaultProps() {
    return {
      activityTabIsSelected: false
    };
  },
  getInitialState: function getInitialState() {
    this.timelineSpinnerRef = _react.default.createRef();
    return {
      startTime: performance.now()
    };
  },
  componentDidMount: function componentDidMount() {
    if (window) {
      this.scrollHandler = (0, _throttle.default)(250, this.handleShowMore);
      window.addEventListener('scroll', this.scrollHandler, true);
    }
  },
  componentDidUpdate: function componentDidUpdate() {
    this.handleShowMore();
  },
  componentWillUnmount: function componentWillUnmount() {
    if (window) {
      window.removeEventListener('scroll', this.scrollHandler, true);
      this.scrollHandler.cancel();
    }
  },
  getIntervals: function getIntervals() {
    return {
      polling: {
        handler: this.handleTimelinePolling,
        timeout: POLLING_INTERVAL
      }
    };
  },
  shouldRenderCreateSourceEvent: function shouldRenderCreateSourceEvent() {
    var _this$props = this.props,
        subject = _this$props.subject,
        favoriteEventOverride = _this$props.favoriteEventOverride,
        timelineStatus = _this$props.timelineStatus,
        activityTabIsSelected = _this$props.activityTabIsSelected;
    var hasStartedFirstFetch = timelineStatus.get('isFetching') !== undefined;
    return activityTabIsSelected && (!favoriteEventOverride || Boolean(!timelineStatus.get('isFetching')) || Boolean(!timelineStatus.get('hasMore')) || hasStartedFirstFetch || subject);
  },
  hasEventsForOverride: function hasEventsForOverride() {
    var timelineStatus = this.props.timelineStatus;
    return timelineStatus.get('hasMore') || timelineStatus.get('events') && timelineStatus.get('events').size;
  },
  isLoadingSpinnerVisible: function isLoadingSpinnerVisible() {
    var timelineStatus = this.props.timelineStatus;

    if (timelineStatus.get('isFetching') || !timelineStatus.get('hasMore')) {
      return false;
    }

    if (!this.timelineSpinnerRef.current) {
      return false;
    }

    return _reactDom.default.findDOMNode(this.timelineSpinnerRef.current).getBoundingClientRect().top < window.innerHeight;
  },
  handleShowMore: function handleShowMore() {
    var _this$props2 = this.props,
        timelineStatus = _this$props2.timelineStatus,
        objectType = _this$props2.objectType,
        subjectId = _this$props2.subjectId,
        timelineFavoriteEvents = _this$props2.timelineFavoriteEvents;

    if (!this.isLoadingSpinnerVisible()) {
      return;
    }

    var nextTimestamp = timelineStatus.get('nextTimestamp');
    var originalPayload = (0, _immutable.Map)({
      eventOptions: timelineFavoriteEvents,
      fromDate: _I18n.default.moment.userTz(nextTimestamp).startOf(months).valueOf(),
      now: now,
      objectType: objectType,
      subjectId: subjectId,
      toDate: nextTimestamp,
      selectedTeams: this.props.selectedTeams,
      selectedUsers: this.props.selectedUsers
    });
    (0, _TimelineFetchingActions.fetchNextTimelineEvents)(originalPayload);
  },
  handleTimelinePolling: function handleTimelinePolling() {
    var _this$props3 = this.props,
        objectType = _this$props3.objectType,
        subjectId = _this$props3.subjectId,
        timelineFavoriteEvents = _this$props3.timelineFavoriteEvents;
    var pollingTimeout = POLLING_INTERVAL + ONE_MINUTE;

    var pollFromTimestamp = _I18n.default.moment.userTz().subtract(pollingTimeout, 'ms').valueOf();

    var originalPayload = (0, _immutable.Map)({
      eventOptions: timelineFavoriteEvents,
      fromDate: pollFromTimestamp,
      now: now,
      objectType: objectType,
      subjectId: subjectId
    });
    (0, _TimelineFetchingActions.fetchMostRecentActivities)(originalPayload);
  },
  maybeRenderCreateSourceEvent: function maybeRenderCreateSourceEvent() {
    var _this$props4 = this.props,
        objectType = _this$props4.objectType,
        subject = _this$props4.subject,
        subjectId = _this$props4.subjectId;

    if (!this.shouldRenderCreateSourceEvent()) {
      return null;
    }

    var timelineItem = (0, _immutable.Map)({
      etype: _ETypes.default.eventCreateSource
    });
    return _react.default.createElement(_TimelineCard.default, {
      TimelineEvent: _TimelineCreateSourceEvent.default,
      objectType: objectType,
      subjectId: subjectId,
      timelineItem: timelineItem,
      subject: subject
    });
  },
  renderLoadingOrError: function renderLoadingOrError() {
    var _this$props5 = this.props,
        timelineStatus = _this$props5.timelineStatus,
        timelineFavoriteEvents = _this$props5.timelineFavoriteEvents,
        objectType = _this$props5.objectType;

    if (timelineStatus.get('status') === _TimelineConstants.TIMELINE_STATUSES.ERROR) {
      return _react.default.createElement(_ProfileTimelineErrorMessage.default, {
        errorMessageType: _customErrorTypes.TIMELINE,
        objectType: objectType
      });
    }

    if (timelineFavoriteEvents && timelineFavoriteEvents.size === 0) {
      return null;
    }

    var hasMore = !!timelineStatus.get('hasMore');

    if (!hasMore) {
      return null;
    }

    return _react.default.createElement("div", {
      className: "p-top-2 p-bottom-6 justify-center",
      "data-selenium-test": "timeline-loading-spinner"
    }, _react.default.createElement(_UILoadingSpinner.default, {
      ref: this.timelineSpinnerRef
    }));
  },
  renderZeroState: function renderZeroState(noResults, onResetFilters) {
    return _react.default.createElement(_TimelineZeroStateAdvancedFilters.default, {
      key: "filters-zero-state",
      noResults: noResults,
      onResetFilters: onResetFilters
    });
  },
  renderTimelineContent: function renderTimelineContent() {
    return _react.default.createElement(_react.Fragment, null, _react.default.createElement(_TimelineStickyEvent.default, {
      activityTabIsSelected: this.props.activityTabIsSelected,
      emailTabIsSelected: this.props.emailTabIsSelected,
      subject: this.props.subject
    }), _react.default.createElement(_TimelineEvents.default, {
      EventComponent: _TimelineEventContainer.default,
      onTimelineEventsChanged: this.scrollHandler,
      PinnedEventComponent: _TimelinePinnedEngagement.default,
      profileStartTime: this.props.profileStartTime,
      subject: this.props.subject,
      timelineLoadStartTime: this.state.startTime
    }), this.renderLoadingOrError(), this.maybeRenderCreateSourceEvent());
  },
  render: function render() {
    var _this$props6 = this.props,
        subject = _this$props6.subject,
        timelineFavoriteEvents = _this$props6.timelineFavoriteEvents,
        objectType = _this$props6.objectType;

    if (!subject || !_immutable.Iterable.isIterable(subject)) {
      return null;
    }

    var hasFiltersSelected = Boolean(timelineFavoriteEvents && timelineFavoriteEvents.size);

    if (this.props.activityTabIsSelected) {
      if (!hasFiltersSelected) {
        return this.renderZeroState(true);
      }

      if (!(0, _TimelineEventHelpers.hasEvents)(this.props.events, this.props.timelineStatus, this.props.hasPinnedEngagement)) {
        var isUsingAdvancedFilters = (this.props.searchText.length || this.props.selectedUsers.size || this.props.selectedTeams.size) > 0;

        if (!this.shouldRenderCreateSourceEvent() || isUsingAdvancedFilters) {
          return this.renderZeroState(true, function () {
            return _TimelineFilterHelpers.default.handleResetFilters(objectType);
          });
        }
      }
    }

    return this.renderTimelineContent();
  }
});
var _default = Timeline;
exports.default = _default;
module.exports = exports.default;